import React, { useEffect } from 'react';
import { Flex, Heading, Menu, MenuButton, MenuList, IconButton, Image, Box, MenuItem, useBreakpointValue } from '@chakra-ui/react';
import {
    useLocation,
    Link as RouterLink,
  } from 'react-router-dom';

  import { ChevronDownIcon } from '@chakra-ui/icons';
function Header({setCountry, country}) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const countryParam = searchParams.get('country');
  const isMobile = useBreakpointValue({ base: true, md: false });
  if(!!countryParam  && countryParam !== country) {
    setCountry(countryParam);
  }
  const countryNames = {
    mexico: 'México',
    chile: 'Chile'
  };

  const countryFlags = {
    mexico: '/mexico-flag.png',
    chile: '/chile-flag.png'
  };
    
  return (
    <Flex align="center" mr={5} pl={20} >
            {/* ...otros elementos del encabezado... */}
            <Heading as="h1" size="lg" letterSpacing="-.1rem" color={'blue.400'}>
            <RouterLink to="/">Data</RouterLink>
            </Heading>
            <Heading as="h1" size="lg" letterSpacing="-.1rem" ml={1} >
            <RouterLink to="/">Partners</RouterLink>
            </Heading>
            {!isMobile && (
      <img src="/logo-ds.png" alt="DataScope Logo" style={{ marginLeft: "15px", maxWidth: "120px" }} />
    )}
            <Menu>
      </Menu>
          </Flex>
  );


}

export default Header;